
import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { Observable } from 'rxjs';
import { tap, map, take } from 'rxjs/operators';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from "@angular/router";
import { NotificationService } from "../shared/notification.service";

@Injectable({ providedIn: 'root' })export class AuthGaurd implements CanActivate {
  user;
  constructor(public authService: AuthService, private router: Router, private notification: NotificationService) {

  }
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let routeData = route.data['breadcrumb'];
    const requiresSuperAdmin = route.data['breadcrumb'] === 'isSuperAdmin';
    if (routeData)
      routeData = routeData.toLowerCase();
    if (route.params['siteId']) {
      let checkSiteAccess = await this.authService.canAccessSite(route.params['siteId'])
      if (checkSiteAccess == false) {
        this.notification.showNotification("info", "You are not allowed to use this site");
        this.router.navigate(['/dashboard'])
        return false;
      }
    }

    let user = await this.authService.user$.pipe(take(1)).toPromise();
    if (this.authService.isAuthenticated()) {
      if (route.data['breadcrumb'] === 'driverManager'
        && !this.authService.isSuperAdmin(user)
        && !(await this.authService.isDriverManager())) {
        this.notification.showNotification("info", "You are not allowed to use this service");
        this.router.navigate(['/dashboard']);
        return false;
      }
      if (route.data['breadcrumb'] === 'powerOfficeLog' && !(await this.authService.canSeePowerOfficeLog())) {
        this.router.navigate(['/dashboard']);
        return false;
      }
      if (requiresSuperAdmin && !this.authService.isSuperAdmin(user)) {
        this.notification.showNotification("info", "You are not allowed to use this service");
        this.router.navigate(['/dashboard']);
        return false;
      }

      if (routeData !== 'drivermanager' && user[routeData] == false) {
        this.notification.showNotification("info", "You are not allowed to use this service");
        return false;
      }
      else
        return true;
    } else {
      this.router.navigate(['/signin'], {
        //   queryParams: {
        //     return: state.url
        //   }
      });
      return false;
    }
  }
  // canActivate(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean> {

  //   return this.authService.user$.pipe(
  //     take(1),
  //     map(user => user && user.roles.admin ? true : false),
  //     tap(isAdmin => {
  //       if (!isAdmin) {
  //         console.error('Access denied - Admins only')
  //       }
  //     })
  //   );
  // }
}


export class CanReadGuard  {

  constructor(public auth: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {

    return this.auth.user$.pipe(
      take(1),
      map(user => user && this.auth.canRead(user) ? true : false), // <-- important line
      tap(canView => {
        if (!canView) {
          console.error('Access denied. Must have permission to view content')
        }
      })
    );
  }
}